/* ============================================================================
   CART BUNDLE SYNC — built for the Expression theme cart-template.liquid /
   cart-item.liquid markup you're using (jQuery, line-index based
   /cart/change.js calls, .quantity-adjuster__input, arrow-link increments).
   ============================================================================

   WHAT THIS DOES
   ----------------------------------------------------------------------------
   - Every cart line item that embroidery-options.liquid or dtf-options.liquid
     adds carries a hidden "Bundle ID" property (plus "_type": "primary" |
     "secondary", and for secondary lines, "Position"). If a customer selects
     BOTH embroidery and DTF, their two secondary lines share the SAME Bundle
     ID as the main product — this script handles any number of secondary
     lines per bundle, not just one.
   - Whenever a "primary" (main product) line's quantity changes — via the
     +/- links, typing in the quantity box, or the "Update" button — this
     script recalculates the SUM of every primary line sharing that Bundle ID
     and pushes that sum onto EVERY secondary line in that bundle. There's
     only one variant per position — your quantity-discount app applies the
     correct tiered price to that variant automatically, so this script never
     needs to swap variants, only keep quantities matched.

   INSTALL
   ----------------------------------------------------------------------------
   1. Save this as assets/cart-bundle-sync.js
   2. Include it near the bottom of cart-template.liquid, AFTER jQuery has
      loaded:
         <script src="{{ 'cart-bundle-sync.js' | asset_url }}" defer></script>
   3. DELETE the two <script> blocks currently embedded at the bottom of
      cart-item.liquid (the commented-out ajaxSuccess version and the active
      polling version) — this file replaces both. Leaving them in will cause
      duplicate/competing cart updates.
   4. Make sure "Enable automatic cart updates" stays ON in the Cart section
      settings (section.settings.enable_ajax_updates). This script takes over
      the "Update" button via ajax itself (see below), but the +/- links only
      get intercepted client-side when ajax updates are on — otherwise the
      browser does a full page navigation and no JS runs to sync anything.
   5. If line-item properties starting with "_" aren't already hidden by
      your theme, add this near the top of snippets/line-item-properties.liquid:
         {%- assign prop_name = property.first | slice: 0 -%}
         {%- if prop_name == '_' -%}{%- continue -%}{%- endif -%}
   ============================================================================ */

(function ($) {
  if (!$) { console.error('[bundle-sync] jQuery not found — this script requires it.'); return; }

  var BUNDLE_PROP = 'Bundle ID';
  var TYPE_PROP = '_type';
  var POSITION_PROP = 'Position';

  var syncTimer = null;
  var inProgress = false;

  function groupByBundle(cart) {
    var bundles = {};
    cart.items.forEach(function (item, idx) {
      var props = item.properties || {};
      var bid = props[BUNDLE_PROP];
      if (!bid) return;
      bundles[bid] = bundles[bid] || { primary: [], secondary: [] };
      var entry = { line: idx + 1, variantId: item.variant_id, quantity: item.quantity, key: item.key };
      if (props[TYPE_PROP] === 'primary') {
        bundles[bid].primary.push(entry);
      } else if (props[TYPE_PROP] === 'secondary') {
        entry.position = props[POSITION_PROP];
        bundles[bid].secondary.push(entry);
      }
    });
    return bundles;
  }

  function changeLineByKey(key, quantity) {
    return $.ajax({ type: 'POST', url: '/cart/change.js', data: { id: key, quantity: quantity }, dataType: 'json' });
  }

  function refreshCartDisplay() {
    $.ajax({
      type: 'GET',
      url: '/cart?view=ajax',
      success: function (data) {
        var toReplace = ['.cart-items', '.cart-subtotal-and-discounts'];
        var $newDom = $('<div>' + data + '</div>');
        $newDom.find('.fade-in').removeClass('fade-in');
        for (var i = 0; i < toReplace.length; i++) {
          $('[data-section-type="cart"] ' + toReplace[i]).html($newDom.find(toReplace[i]).html());
        }
      }
    });
  }

  function reconcileAllBundles(cart, callback) {
    var bundles = groupByBundle(cart);
    var bundleIds = Object.keys(bundles);
    var work = $.when();

    bundleIds.forEach(function (bid) {
      var bundle = bundles[bid];
      if (!bundle.secondary.length) return; // nothing to sync for this bundle

      var primaryTotal = bundle.primary.reduce(function (sum, p) { return sum + p.quantity; }, 0);

      bundle.secondary.forEach(function (secondary) {
        work = work.then(function () {
          if (primaryTotal <= 0) {
            // All primary items removed from this bundle — drop this add-on
            // line too. Using the line's stable key rather than its
            // position, since removing one secondary line shifts every
            // later line's position out from under a queued call — this
            // matters now that a bundle can have more than one secondary
            // (embroidery + DTF together).
            return changeLineByKey(secondary.key, 0);
          }
          if (secondary.quantity === primaryTotal) return $.when(); // already correct, no-op
          return changeLineByKey(secondary.key, primaryTotal);
        });
      });
    });

    work.always(function () { if (callback) callback(); });
  }

  function runSync() {
    if (inProgress) return;
    inProgress = true;
    $.getJSON('/cart.js', function (cart) {
      reconcileAllBundles(cart, function () {
        inProgress = false;
        refreshCartDisplay();
      });
    }).fail(function () { inProgress = false; });
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    // Wait out the theme's own ajax cart-change call before we re-read /cart.js
    syncTimer = setTimeout(runSync, 900);
  }

  // ---- triggers ----------------------------------------------------------
  // +/- links (?line=X&quantity=Y) — presumably intercepted by the theme's
  // own ajax handler when enable_ajax_updates is on.
  $(document).on('click', '.quantity-adjuster__button--down a, .quantity-adjuster__button--up a', function () {
    scheduleSync();
  });

  // Typing directly into the quantity box.
  $(document).on('change keyup', '.quantity-adjuster__input', function () {
    scheduleSync();
  });

  // The "Update cart" button — run it via ajax ourselves so we can sync
  // bundles before the page reloads, instead of a full form POST.
  $(document).on('click', 'input[name="update"]', function (e) {
    e.preventDefault();
    var updates = {};
    $('.quantity-adjuster__input').each(function () {
      var line = $(this).data('line');
      updates[line] = parseInt($(this).val() || 0, 10);
    });

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: JSON.stringify({ updates: updates }),
      contentType: 'application/json',
      dataType: 'json'
    }).always(function () { runSync(); });
  });

  // Safety net for anything else that changes the cart (e.g. an app).
  $(document).ajaxSuccess(function (event, xhr, settings) {
    if (!settings.url) return;
    if (settings.url.indexOf('cart/change') !== -1 || settings.url.indexOf('cart/update') !== -1) {
      if (!inProgress) scheduleSync();
    }
  });
})(window.jQuery);
